import { createSelector } from 'reselect';
//@ts-expect-error not typed
import { getLanguageNameFromKey } from 'ContentEditorUI/utils/multiLangUtils';
import { AccessControlTypes } from 'ui-memberships-settings-lib/constants/AccessControlTypes';
import { PublicAccessRuleTypes } from 'ui-memberships-settings-lib/constants/PublicAccessRuleTypes';
import { selectIsUngatedForThemeSettingsVariant } from '../../auth/selectors/auth';
import RequestStatus from '../../types/RequestStatus';
import { selectAccessRuleType, selectArticleTranslations } from './articleInstanceSelectors';
export const selectKnowledgeBaseGroup = state => state.knowledgeBaseGroup.knowledgeBase;
export const selectKnowledgeBaseCategories = state => state.knowledgeBaseGroup.categories;
export const selectKnowledgeBaseFetchStatus = state => state.knowledgeBaseGroup.requestStatus;
export const selectCategoriesRequestStatus = state => state.knowledgeBaseGroup.categoryRequestStatus;
export const createKnowledgeBaseValueSelector = field => createSelector([selectKnowledgeBaseGroup], currentKnowledgeBase => {
  var _currentKnowledgeBase, _currentKnowledgeBase2;
  return (_currentKnowledgeBase = currentKnowledgeBase === null || currentKnowledgeBase === void 0 || (_currentKnowledgeBase2 = currentKnowledgeBase.values) === null || _currentKnowledgeBase2 === void 0 ? void 0 : _currentKnowledgeBase2[field]) !== null && _currentKnowledgeBase !== void 0 ? _currentKnowledgeBase : undefined;
});
export const selectKnowledgeBaseSlug = createKnowledgeBaseValueSelector('hs_slug');
export const selectKnowledgeBaseThemeVariant = createSelector([selectIsUngatedForThemeSettingsVariant, createKnowledgeBaseValueSelector('hs_id'), createKnowledgeBaseValueSelector('hs_theme_settings_id')], (ungated, kbId, themeSettingsId) => {
  return ungated ? kbId : themeSettingsId;
});
export const selectKnowledgeBaseDomain = createKnowledgeBaseValueSelector('hs_domain');
export const selectKnowledgeBaseRuleType = createKnowledgeBaseValueSelector('hs_access_rule_type');
export const selectKnowledgeBaseLanguage = createKnowledgeBaseValueSelector('hs_language');
export const selectKnowledgeBaseTranslations = createSelector([selectKnowledgeBaseGroup], knowledgeBase => knowledgeBase.translations || {});
export const selectAllKnowledgeBaseLanguages = createSelector([selectKnowledgeBaseGroup, selectKnowledgeBaseTranslations, selectKnowledgeBaseFetchStatus], (knowledgeBase, translations, requestStatus) => {
  if (requestStatus !== RequestStatus.SUCCEEDED) {
    return {};
  }
  return Object.assign({
    [knowledgeBase.values.hs_language]: knowledgeBase
  }, translations);
});
export const selectKnowledgeBaseHasLoaded = createSelector([selectKnowledgeBaseFetchStatus], fetchStatus => fetchStatus === RequestStatus.SUCCEEDED);
export const selectPrimaryKnowledgeBase = createSelector([selectKnowledgeBaseGroup, selectKnowledgeBaseTranslations, selectKnowledgeBaseHasLoaded], (knowledgeBase, translations, kbHasLoaded) => {
  if (!kbHasLoaded) {
    return null;
  }
  return [...Object.values(translations), knowledgeBase].find(kbInfo => {
    return !kbInfo.values.hs_translated_from_id;
  });
});
export const selectPrimaryKnowledgeBaseLanguage = createSelector([selectPrimaryKnowledgeBase], knowledgeBase => knowledgeBase && knowledgeBase.values.hs_language);

// Returns an array of options for the various Kbs that the article can be translated to
export const selectVariantCreationOptions = createSelector([selectKnowledgeBaseTranslations, selectArticleTranslations], (kbTranslationsMap, articleTranslations) => {
  const possibleChoices = Object.values(kbTranslationsMap).filter(kbInfo => {
    return !articleTranslations.some(article => article.values.hs_language === kbInfo.values.hs_language);
  }).map(val => ({
    text: getLanguageNameFromKey(val.values.hs_language),
    value: val.values.hs_id
  }));
  return possibleChoices;
});
export const selectHasAudienceControlMismatch = createSelector([selectAccessRuleType, selectKnowledgeBaseRuleType], (articleAccessType, knowledgeBaseAccessRuleType) => {
  switch (knowledgeBaseAccessRuleType) {
    case PublicAccessRuleTypes.ACCESS_GROUP_MEMBERSHIP:
      return articleAccessType !== PublicAccessRuleTypes.ACCESS_GROUP_MEMBERSHIP;
    case PublicAccessRuleTypes.SSO_LOGIN:
      return articleAccessType !== PublicAccessRuleTypes.SSO_LOGIN;
    default:
      return false;
  }
});
export const selectAvailableAccessOptionsForArticle = createSelector([selectKnowledgeBaseRuleType], knowledgeBaseAccessRuleType => {
  switch (knowledgeBaseAccessRuleType) {
    case PublicAccessRuleTypes.PUBLIC:
      return {
        [AccessControlTypes.PUBLIC]: true,
        [AccessControlTypes.ACCESS_GROUP_MEMBERSHIP]: true,
        [AccessControlTypes.SSO]: true,
        [AccessControlTypes.SSO_WITH_ACCESS_GROUPS]: true
      };
    case PublicAccessRuleTypes.ACCESS_GROUP_MEMBERSHIP:
      return {
        [AccessControlTypes.ACCESS_GROUP_MEMBERSHIP]: true
      };
    case PublicAccessRuleTypes.SSO_LOGIN:
      return {
        [AccessControlTypes.SSO]: true
        // TODO: Add SSO_WITH_ACCESS_GROUPS after HubDB validation accepts this
      };
    default:
      return {};
  }
});